import { useNavigate } from "react-router-dom";
import { PROGRAMS, setActiveProgramId, isProgramVisible } from "@/data/program";
import { useAuth } from "@/context/AuthContext";
import { ChevronRight, Lock, Dumbbell } from "lucide-react";

export default function Select() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const choose = (id) => {
    const p = PROGRAMS.find((prog) => prog.id === id);
    if (!p || !isProgramVisible(p, user?.email)) return;
    setActiveProgramId(id);
    navigate("/");
  };

  return (
    <div className="mx-auto w-full max-w-md min-h-screen bg-[#0a0a0a] px-5 pt-16 pb-10 animate-slideup">
      <p className="font-head text-sm uppercase tracking-[0.3em] text-[#fa003f]">Scegli</p>
      <h1 className="font-head text-4xl font-black uppercase tracking-tight text-white">
        Il tuo programma
      </h1>
      <p className="text-sm text-zinc-500 mt-1">Seleziona il percorso che vuoi seguire.</p>

      <div className="mt-8 space-y-3">
        {PROGRAMS.filter((p) => isProgramVisible(p, user?.email)).map((p) => {
          const locked = !!p.comingSoon;
          return (
            <button
              key={p.id}
              data-testid={`select-program-${p.id}`}
              disabled={locked}
              onClick={() => !locked && choose(p.id)}
              className={`w-full text-left border p-5 transition-transform ${
                locked
                  ? "border-zinc-900 bg-[#0d0d0d] opacity-70 cursor-not-allowed"
                  : "border-zinc-800 bg-[#141414] active:scale-[0.99]"
              }`}
            >
              <div className="flex items-center justify-between gap-3">
                <div className="min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <Dumbbell size={16} className={locked ? "text-zinc-600" : "text-[#fa003f]"} />
                    {locked && (
                      <span className="border border-zinc-700 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-zinc-400">
                        Presto
                      </span>
                    )}
                  </div>
                  <h2 className="font-head text-3xl font-bold uppercase tracking-tight text-white">
                    {p.name}
                  </h2>
                  <p className="text-xs text-zinc-500">
                    {locked ? "In arrivo" : "Tocca per iniziare"}
                  </p>
                </div>
                {locked ? (
                  <Lock size={22} className="text-zinc-600 shrink-0" />
                ) : (
                  <ChevronRight size={26} className="text-[#fa003f] shrink-0" />
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
